var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('RelaxifyHeader'),_c('div',{staticClass:"RelaxifyNotFound__text"},[_vm._v(" "+_vm._s('Page Not Found !'))]),_c('RelaxifyFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }